import { Box, Flex, Text } from "@chakra-ui/react";
import { LanguageIcon } from "@root/assets/icons";
import { EngIcon } from "@root/assets/icons/engIcon";
import { APP_THEME, LANGUAGE } from "@root/constants";
import useLanguage from "@root/hooks/useLanguage";
import { testId as testIdFn } from "@root/utils/e2e";
import { color } from "framer-motion";
import { FC, useEffect, useState } from "react";
import Select, { Props } from "react-select";

interface ISelectProps extends Props {
  testID?: string;
  keys: string[];
  allOption?: boolean;
  selectionIcon?: boolean;
}
interface Option {
  value: string | number;
  label: string | number;
}

const findKeysInArray = (arr: any, keys: string[]): Option[] => {
  const array = arr.reduce((result: Option[], obj: any) => {
    const values: Option = {
      value: obj[keys[0]],
      label: obj[keys[1]],
    };

    return result.concat(values);
  }, []);

  return array;
};

export const customStyles = (currentTheme: any) => {
  const defaultStyles = {
    fontSize: "12px",
    fontWeight: "400",
  };

  return {
    control: (styles: any) => ({
      ...styles,
      borderColor: "theme.gray.100",
      borderRadius: "8px",
      borderWidth: "1px",
      padding: "1px",
      backgroundColor: 'primary.500',
      color: 'primary.600',
      height: '55px',
      width: '100%',
      boxShadow: 0,
      paddingLeft: '10px',
      paddingRight: '10px',
      ":hover": {
        border: '1px solid',
        borderColor: 'theme.gray.100',
        outline: 0,
        boxShadow: 0
      }
    }),
    option: (styles: any, { isSelected }: any) => ({
      ...styles,
      ...defaultStyles,
      backgroundColor: 'transparent',
      color: currentTheme === APP_THEME.DARK ? '#FFF' : "#000",
      ":active": {
        ...styles[":active"],
      },
    }),
    input: (styles: any) => ({
      ...styles,
      ...defaultStyles,
    }),
    placeholder: (styles: any) => ({ ...styles, ...defaultStyles }),
    singleValue: (styles: any) => ({
      ...styles,
      ...defaultStyles,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menuList: (provided: any) => ({
      ...provided,
      backgroundColor: currentTheme === APP_THEME.DARK ? '#2F3438' : '#FFFFFF',
    }),
    clearIndicator: (styles: any, { isFocused }: any) => ({
      ...styles,
      ...(isFocused ? {} : { display: "none" }),
    }),
  };
};

export const StyledSelect: FC<ISelectProps> = ({
  options = [],
  keys = ["id"],
  testID = "",
  allOption,
  styles,
  selectionIcon = true,
  ...props
}) => {
  const [updatedOptions, setupdatedOptions] = useState<any>([]);
  const currentTheme = localStorage.getItem("chakra-ui-color-mode");
  const { handleUpdateLanguage, currentLanguage } = useLanguage()

  useEffect(() => {
    const updatedData = findKeysInArray(options, keys);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    allOption ? updatedData.unshift({ value: "", label: "All" }) : null;
    setupdatedOptions(updatedData);
  }, [options]);


  useEffect(() => {
  }, [currentTheme]);

  const IconSingleValue = (props: any) => (
    <Flex alignItems="center" mt={"-25px"} p={'5px'} >
      {selectionIcon && (
        <Box ml={5} marginLeft={0}>
          {
            currentLanguage === 'EN' ?
              <EngIcon /> :
              <LanguageIcon />
          }
        </Box>
      )}
      <Text ml={3}>{currentLanguage !== 'EN' ? "Korean" : 'English'}</Text>
    </Flex>
  );

  const languageSwitchHandler = (event: any) => {
    if (event?.value === 'KO') {
      handleUpdateLanguage(LANGUAGE.KOREAN)
    } else {
      handleUpdateLanguage(LANGUAGE.ENGLISH)
    }
  }

  return (
    <Select
      {...props}
      onChange={languageSwitchHandler}
      options={updatedOptions}
      styles={customStyles(currentTheme)}
      components={{ SingleValue: IconSingleValue }}
      isSearchable={false}
      {...(testID ? testIdFn(testID) : {})}
    />
  );
};
